module.exports = __webpack_public_path__ + "static/media/puffy original design.de784623.png";